import React, { useEffect, useState } from 'react';
import { Button } from '../ui/Button';
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-primary/95 backdrop-blur-lg shadow-lg border-b border-border py-3' : 'bg-transparent py-5'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between" data-id="element-51">
        <Link to="/" className="flex items-center" data-id="element-52">
          <span className="text-2xl font-bold text-white tracking-tight" data-id="element-53">
            Petite<span className="text-accent" data-id="element-54">Style</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center space-x-8 text-sm font-medium" data-id="element-55">
          <a href="#how-it-works" className="text-text-muted hover:text-white transition-colors" data-id="element-56">
            How It Works
          </a>
          <a href="#vendors" className="text-text-muted hover:text-white transition-colors" data-id="element-57">
            Vendors
          </a>
          <a href="#virtual-try" className="text-text-muted hover:text-white transition-colors" data-id="element-58">
            Virtual Try-On
          </a>
          <a href="#contact" className="text-text-muted hover:text-white transition-colors" data-id="element-59">
            Contact
          </a>
        </nav>

        <div className="flex items-center space-x-4" data-id="element-60">
          <button className="text-text-muted hover:text-white transition-colors" data-id="element-61">
            <span className="text-sm font-medium" data-id="element-62">Log in</span>
          </button>
          <Button variant="primary" size="md" onClick={() => navigate('/try-it')} data-id="element-63">
            Get Started
          </Button>
        </div>
      </div>
    </motion.header>;
}